import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "oauth-wrapper" }
const _hoisted_2 = { class: "form-fields" }
const _hoisted_3 = { class: "form-actions" }
const _hoisted_4 = { class: "footer-text" }

import { reactive } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import AuthLayout from "@/components/auth/AuthLayout.vue";
import OAuthButtons from "@/components/auth/OAuthButtons.vue";
import BaseInput from "@/components/ui/BaseInput.vue";
import BaseButton from "@/components/ui/BaseButton.vue";
import BaseCheckbox from "@/components/ui/BaseCheckbox.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SignUpView',
  setup(__props) {

const router = useRouter();
const authStore = useAuthStore();

const form = reactive({
  email: "",
  password: "",
  confirmPassword: "",
  agreed: false,
});

const errors = reactive({
  email: "",
  password: "",
  confirmPassword: "",
  agreed: false,
});

function validate() {
  let valid = true;

  errors.email = "";
  errors.password = "";
  errors.confirmPassword = "";
  errors.agreed = false;

  if (!form.email.trim()) {
    errors.email = "Required";
    valid = false;
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
    errors.email = "Invalid email";
    valid = false;
  }

  if (!form.password) {
    errors.password = "Required";
    valid = false;
  } else if (form.password.length < 8) {
    errors.password = "Min. 8 characters";
    valid = false;
  }

  if (!form.confirmPassword) {
    errors.confirmPassword = "Required";
    valid = false;
  } else if (form.password !== form.confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
    valid = false;
  }

  if (!form.agreed) {
    errors.agreed = true;
    valid = false;
  }

  return valid;
}

function handleOAuth(provider: string) {
  return provider;
}

function handleSubmit() {
  if (!validate()) return;
  authStore.login();
  router.push("/dashboard");
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(AuthLayout, {
    label: "Get Started",
    title: "Create your account",
    subtitle: "Join thousands of users building amazing projects"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(OAuthButtons, { onOauth: handleOAuth })
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "divider" }, [
        _createElementVNode("div", { class: "divider-line" }),
        _createElementVNode("span", { class: "divider-text" }, "Or continue with email"),
        _createElementVNode("div", { class: "divider-line" })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseInput, {
          modelValue: form.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
          label: "Email address",
          type: "email",
          placeholder: "you@example.com",
          icon: "mail",
          error: errors.email
        }, null, 8, ["modelValue", "error"]),
        _createVNode(BaseInput, {
          modelValue: form.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
          label: "Password",
          type: "password",
          placeholder: "Create a password",
          icon: "lock",
          error: errors.password
        }, null, 8, ["modelValue", "error"]),
        _createVNode(BaseInput, {
          modelValue: form.confirmPassword,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.confirmPassword) = $event)),
          label: "Confirm password",
          type: "password",
          placeholder: "Confirm your password",
          icon: "lock",
          error: errors.confirmPassword
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseCheckbox, {
          modelValue: form.agreed,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.agreed) = $event)),
          error: errors.agreed
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" I agree to the ", -1),
            _createElementVNode("a", { href: "#" }, "Terms of Service", -1),
            _createTextVNode(" and ", -1),
            _createElementVNode("a", { href: "#" }, "Privacy Policy", -1)
          ]))]),
          _: 1
        }, 8, ["modelValue", "error"]),
        _createVNode(BaseButton, {
          type: "submit",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" Create account ", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_4, [
          _cache[7] || (_cache[7] = _createTextVNode(" Already have an account? ", -1)),
          _createVNode(_component_RouterLink, { to: "/sign-in" }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Sign in", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})